import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux'
import { Provider } from "react-redux";
import reducer from "./redux/reducer";
import { BrowserRouter } from 'react-router-dom';
import './locales/i18n';
import App from './App';
import { Quill } from 'react-quill';
//import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
window.Quill = Quill;

let store = createStore(reducer);
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={baseUrl}>
      <App/>
    </BrowserRouter>
  </Provider>,
  rootElement);

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();

